export enum CookiesEnum {
    ads = "marketing",
    analytics = "statistic",
    necessary = "necessary",
}